
<template>
    <DsModal
        size="med"
        :title="$t('funnel.edit.campaign.element.not.supported.title')"
        is-open
        show-close
        @close="$emit('close-modal')"
    >
        <template #header>
            <DsFilledButton @click="$emit('close-modal')">
                {{ $t('global.done') }}
            </DsFilledButton>
        </template>

        <p>
            {{ $t('funnel.edit.campaign.element.not.supported.text') }}
        </p>
    </DsModal>
</template>

<script>
export default {
    props: {
        cell: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['close-modal'],
};
</script>
